module.exports = __webpack_public_path__ + "static/media/cmr_4.c87d2c52.jpg";